var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5L5 8.5V16.5M9 8.5H12C12.2652 8.5 12.5196 8.60536 12.7071 8.79289C12.8946 8.98043 13 9.23478 13 9.5V11.5C13 11.7652 12.8946 12.0196 12.7071 12.2071C12.5196 12.3946 12.2652 12.5 12 12.5H10C9.73478 12.5 9.48043 12.6054 9.29289 12.7929C9.10536 12.9804 9 13.2348 9 13.5V15.5C9 15.7652 9.10536 16.0196 9.29289 16.2071C9.48043 16.3946 9.73478 16.5 10 16.5H13M17 8.5H19.5C19.8978 8.5 20.2794 8.65804 20.5607 8.93934C20.842 9.22064 21 9.60218 21 10V11C21 11.3978 20.842 11.7794 20.5607 12.0607C20.2794 12.342 19.8978 12.5 19.5 12.5M19.5 12.5H18M19.5 12.5C19.8978 12.5 20.2794 12.658 20.5607 12.9393C20.842 13.2206 21 13.6022 21 14V15C21 15.3978 20.842 15.7794 20.5607 16.0607C20.2794 16.342 19.8978 16.5 19.5 16.5H17",
    stroke: "#00332D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberActive);
export default __webpack_public_path__ + "static/media/numberActive.4d2e7600b09af539fc648e748bdb1dbb.svg";
export { ForwardRef as ReactComponent };